import React, { useState } from "react";

import Button from "react-bootstrap/Button";
import { GET_ACTIVE_LINE_JOB_BY_ID } from "../../graphql/jobs.graphql";
import JobIdModal from "./JobIdModal";
import QRCodeReader from "../QRCodeReader";
import { toast } from "react-toastify";
import { useLazyQuery } from "@apollo/client";
import { useTranslation } from "next-i18next";

const LineInfoSection = ({ line, onChange }) => {
  const { t } = useTranslation();

  const [showButtons, setShowButtons] = useState(false);

  const [openModal, setOpenModal] = useState("");

  const [qrData, setQRData] = useState();

  const [getActiveLineJob] = useLazyQuery(GET_ACTIVE_LINE_JOB_BY_ID, {
    fetchPolicy: "network-only",
  });

  const readJob = async (id, QR) => {
    getActiveLineJob({ variables: { id } })
      .then((response) => {
        const job = response?.data?.line_job[0];
        if (!!job) {
          const selecetdLine = {
            id: job.id,
            label: job.line.is_misc
              ? t("views.checkin.miscLine")
              : `${t("views.checkin.form.lineNumber")} ${job.line.number} - ${
                  job.customer?.name
                }`,
            value: job.id,
            shift: job.shift,
            line_id: job.line.id,
            line_number: job.line.number,
            line_is_misc: job.line.is_misc,
            description: job.item?.description,
            start_time: job.start_time,
            leader_id: job.leader_id,
            line: job.line,
          };

          const location = {
            value: job.line.location.id,
            label: job.line.location.name,
          };

          const processedJob = {
            ...job,
            label: job.line.is_misc
              ? t("views.checkin.miscLine")
              : `${t("views.checkin.form.lineNumber")} ${job.line.number} - ${
                  job.customer?.name
                }`,
            value: job.id,
            shift: job.shift,
            line_id: job.line.id,
            line_number: job.line.number,
            line_is_misc: job.line.is_misc,
            description: job.item?.description,
            start_time: job.start_time,
            leader_id: job.leader_id,
            line: job.line,
          };

          if (QR) {
            setQRData({ line: selecetdLine, location, job: processedJob });
          } else {
            localStorage.setItem("selectedJob", JSON.stringify(processedJob));

            onChange(processedJob);
          }
        } else {
          toast.error(t("views.checkin.job.notFound"));
        }
      })
      .catch((e) => {
        console.log(e);
        toast.error(t("general.somethingWrong"));
      });
  };

  return (
    <React.Fragment>
      <JobIdModal
        open={openModal === "JOB_ID"}
        toggleModal={() => {
          setShowButtons(false);
          setOpenModal("");
        }}
        onSubmit={(job) => readJob(job)}
      />
      <QRCodeReader
        open={openModal === "READ"}
        closeOnRead={false}
        hide={() => {
          setQRData("");
          setShowButtons(false);
          setOpenModal("");
        }}
        onRead={(data) => {
          if (!!data) {
            const params = data
              .split(",")
              .map((p) => p.split("="))
              .reduce((result, item) => {
                result[item[0]] = item[1];
                return result;
              }, {});

            readJob(params["job_id"], true);
          }
        }}
        onSave={() =>  onChange(qrData.job)}
        data={qrData}
        info={
          qrData ? (
            <div className="d-flex flex-column w-75 mt-5">
              <h1 className="mb-0 fw-bold">{qrData?.line?.label}</h1>
              <p className="mb-0">{qrData?.line?.description}</p>
            </div>
          ) : null
        }
      />
      {!!line?.label && !showButtons && (
        <div
          className="d-flex bg-white justify-content-between align-items-center mb-2"
          style={{ minHeight: 116, padding: 32, borderRadius: 11 }}
        >
          <div>
            <h1 className="m-0 me-3 fw-bold">{line.label}</h1>
            {!!line.description && <p className="m-0" style={{ maxWidth: 300 }}>{line.description}</p>}
          </div>

          <div
            className="d-flex justify-content-center align-items-center border border-secondary rounded"
            style={{
              width: 40,
              height: 40,
              cursor: "pointer",
            }}
            onClick={() => {
              setShowButtons(true);
            }}
          >
            <i
              className="bi bi-pencil-fill"
              style={{ color: "#9ba9b5", fontSize: 20 }}
            />
          </div>
        </div>
      )}

      {(showButtons || !line?.label) && (
        <div
          className="d-flex flex-column justify-content-center align-items-center bg-white mb-2"
          style={{ minHeight: 116, padding: 32, borderRadius: 11 }}
        >
          <h2 className="fw-bold">{t("views.checkin.form.setup")}</h2>
          <div className="d-flex w-100 justify-content-center">
            <Button
              variant="primary"
              className="me-2"
              style={{ minWidth: 180 }}
              onClick={() => setOpenModal("READ")}
            >
              {t("views.checkin.form.scan").toUpperCase()}
            </Button>
            <Button
              variant="primary"
              style={{ minWidth: 180 }}
              onClick={() => setOpenModal("JOB_ID")}
            >
              {t("views.checkin.form.insertJob").toUpperCase()}
            </Button>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default LineInfoSection;
